import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
const levels = ['Iniciación', 'Básico', 'Intermedio', 'Avanzado', 'Competitivo', 'Planificación Anual', 'Gestión de Clases'];
const skills = [{
  icon: '🛼',
  text: 'Fundamentos'
}, {
  icon: '⚙️',
  text: 'Técnica'
}, {
  icon: '🔄',
  text: 'Giros y Piruetas'
}, {
  icon: '🦋',
  text: 'Saltos'
}, {
  icon: '💃',
  text: 'Coreografía'
}, {
  icon: '🎵',
  text: 'Música y Expresión'
}, {
  icon: '📅',
  text: 'Planificación'
}, {
  icon: '📊',
  text: 'Evaluación'
}, {
  icon: '📈',
  text: 'Progresión'
}, {
  icon: '👁️',
  text: 'Seguimiento'
}, {
  icon: '💪',
  text: 'Preparación Física'
}, {
  icon: '🤸',
  text: 'Flexibilidad'
}, {
  icon: '🎯',
  text: 'Coordinación'
}, {
  icon: '👨‍👩‍👧',
  text: 'Gestión de Grupos'
}, {
  icon: '🏆',
  text: 'Competencia'
}];
export function ProductOverview() {
  return <Section dark className="bg-brand-dark border-t border-brand-light" data-id="element-281">
      <div className="text-center mb-8 md:mb-16" data-id="element-282">
        <span className="text-brand-accent font-semibold tracking-wider uppercase text-xs md:text-sm mb-2 block" data-id="element-283">
          Sistema N°1 para Profesores de Patinaje Artístico en Argentina
        </span>
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 md:mb-6" data-id="element-284">
          PATINAJE ARTÍSTICO RESUELTO™
        </h2>
        <p className="text-base md:text-xl text-brand-ice/80" data-id="element-285">
          6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
        </p>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-286">
        <div className="bg-brand-light p-4 md:p-8 rounded-xl md:rounded-2xl text-center border border-brand-dark/30" data-id="element-287">
          <div className="text-2xl md:text-5xl font-bold text-brand-accent mb-1 md:mb-2" data-id="element-288">
            +720
          </div>
          <div className="text-xs md:text-base text-brand-ice/80 font-medium" data-id="element-289">
            Páginas de contenido
          </div>
        </div>
        <div className="bg-brand-light p-4 md:p-8 rounded-xl md:rounded-2xl text-center border border-brand-dark/30" data-id="element-290">
          <div className="text-2xl md:text-5xl font-bold text-brand-accent mb-1 md:mb-2" data-id="element-291">
            60+
          </div>
          <div className="text-xs md:text-base text-brand-ice/80 font-medium" data-id="element-292">
            Clases listas para usar
          </div>
        </div>
        <div className="bg-brand-light p-4 md:p-8 rounded-xl md:rounded-2xl text-center border border-brand-dark/30" data-id="element-293">
          <div className="text-2xl md:text-5xl font-bold text-brand-accent mb-1 md:mb-2" data-id="element-294">
            100%
          </div>
          <div className="text-xs md:text-base text-brand-ice/80 font-medium" data-id="element-295">
            Funciona hoy en tu pista
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-12" data-id="element-296">
        {/* Levels */}
        <div className="lg:col-span-1 bg-brand-light p-5 md:p-8 rounded-xl md:rounded-2xl border border-brand-dark/30" data-id="element-297">
          <h3 className="text-lg md:text-2xl font-serif font-bold mb-4 md:mb-6 text-white" data-id="element-298">
            Niveles y enfoques incluidos:
          </h3>
          <ul className="space-y-2 md:space-y-4" data-id="element-299">
            {levels.map((level, i) => <li key={i} className="flex items-center text-sm md:text-lg text-brand-ice/80" data-id="element-300">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-brand-accent mr-2 md:mr-3 flex-shrink-0" data-id="element-301" />
                {level}
              </li>)}
          </ul>
        </div>

        {/* Skills Grid */}
        <div className="lg:col-span-2 bg-brand-light p-5 md:p-8 rounded-xl md:rounded-2xl border border-brand-dark/30" data-id="element-302">
          <h3 className="text-lg md:text-2xl font-serif font-bold mb-4 md:mb-6 text-white" data-id="element-303">
            Todo lo que vas a dominar:
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 md:gap-4" data-id="element-304">
            {skills.map((skill, i) => <div key={i} className="flex items-center bg-brand-dark/50 p-2 md:p-3 rounded-lg border border-brand-dark/30" data-id="element-305">
                <span className="text-lg md:text-2xl mr-2 md:mr-3" data-id="element-306">
                  {skill.icon}
                </span>
                <span className="text-xs md:text-base text-brand-ice/90 font-medium" data-id="element-307">
                  {skill.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}